const fs = require('fs');
const path = require('path');


// method to verify the TikTok data
export function verify_tiktok_data(json_object,
                                donate_like_history=true,
                                donate_search_history=true,
                                donate_share_history=true,
                                donate_session_times=true,
                                donate_favorites=true,
                                donate_following=true,
                                donate_followers=true,
                                donate_comments=true,
                                donate_comments_text=true,
                                donate_ads=true,
                                donate_settings=true) 
{

    var errors = [];

    if ('Your Activity' in json_object){
        var activity = json_object['Your Activity'];
        if(('Watch History' in activity)==false){
            errors.push('Watch History not detected!');
        }
        if (('Watch History' in activity)==true){
            if (('VideoList' in activity['Watch History']) == false) {
                errors.push("VideoList in Watch History is empty!");
            }
            /*
            try{
                var VideoList = activity['Watch History']['VideoList'];
            }
            catch(err){
                errors.push("Watch History is empty!");
            }
            */
        }
        if (('Follower' in activity)==false && donate_followers) {
            errors.push("Follower not detected!");
        }
    
        if (('Following' in activity)==false && donate_following) {
            errors.push("Following not detected!");
        }
    
        if (donate_favorites){
            if (('Favorite Effects' in activity)==false){
                errors.push("Favorite Effects not detected!");
            }
            if (('Favorite Sounds' in activity)==false){
                errors.push("Favorite Sounds not detected!");
            }
            if (('Favorite Hashtags' in activity)==false){
                errors.push("Favorite Hashtags not detected!");
            }
            if (('Favorite Videos' in activity)==false){
                errors.push("Favorite Videos not detected!");
            }
        }
    
        if(donate_like_history){
            if (('Like List' in activity)==false){
                errors.push("Like List not detected!");
            } 
        }
    
        if (donate_search_history){
            if(('Searches' in activity)==false){
                errors.push("Search History not detected!");
            }
        }
    
        if (donate_share_history){
            if (('Share History' in activity)==false){
                errors.push("Share History not detected!");
            }
        }
    
        if (donate_session_times){
            try{
                var login_history_list = activity['Login History']['LoginHistoryList'];
            }
            catch(err){
                errors.push("Session Times not detected!")
            }
        }
    }
    else{
        errors.push("Activity not detected!");
    }
    

    if (donate_comments){
        try{
            var comments = json_object['Comment'];
            var commentList = comments['Comments']['CommentsList'];
        }
        catch(err){
            errors.push("Comments not detected!");
        }
    }

    

    if (donate_settings && ('App Settings' in json_object)==false){
        errors.push("App Settings not detected!");
    }

    if (donate_ads && ('Ads and data' in json_object)==false){
        errors.push("Ads and data not detected!");
        }

    return errors;
}

export default verify_tiktok_data;